
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';


const HeroSection = () => {
  return (
    <section className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background via-blue-light to-blue-dark relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(59,130,246,0.1),transparent_50%)]"></div>
      
      <div className="text-center px-4 max-w-4xl mx-auto relative z-10">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <img 
            src="/lovable-uploads/clr_4.png" 
            alt="Bromentum Logo" 
            className="w-32 h-32 object-contain"
          />
        </div>
        
        <h1 className="text-3xl md:text-5xl font-bold text-foreground mb-4 animate-fade-in">
          ONLY DOGS AND WOMEN ARE LOVED UNCONDITIONALLY
        </h1>
        
        <div className="flex justify-center mb-6">
          <span className="text-2xl md:text-4xl font-bold text-primary bg-gradient-to-r from-primary to-accent-blue bg-clip-text text-transparent">
            BroMentum
          </span>
        </div>
        
        <p className="text-lg md:text-xl text-muted-foreground mb-8 max-w-3xl mx-auto leading-relaxed">
          Supporting men's well-being by turning memes into movements — through decentralized coordination and tokenized culture.
        </p>
        
        <div className="flex justify-center mb-8">
          <Button 
            onClick={() => window.open('https://t.me/BroRankBot?start=initiation', '_blank')}
            size="lg" 
            className="text-lg px-8 py-3 bg-primary hover:bg-primary/90 text-primary-foreground shadow-lg hover:shadow-xl transition-all duration-300 flex items-center gap-2"
          >
            🤖 Start Initiation
          </Button>
        </div>
        
        <p className="text-sm text-muted-foreground mb-12 max-w-2xl mx-auto">
          Start your BroRankBot initiation and connect your wallet to join Bromentum — a decentralized meme-powered brotherhood.
        </p>
        
        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
          <div className="text-center">
            <div className="text-3xl font-bold text-primary mb-2">5000+</div>
            <div className="text-muted-foreground">Active Brothers</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-primary mb-2">1</div>
            <div className="text-muted-foreground">Total Acquisitions</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-primary mb-2">50+</div>
            <div className="text-muted-foreground">Countries</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
